import { Assessment, AssessmentStudent } from '@/common/types/assessment';
import Migrator from '@/common/types/migrations/migrator';
import { ControllerType } from '@/common/types/student';

type LegacyAssessment =
  | {
      students: LegacyAssessmentStudent[];
      doScreener?: boolean;
    }
  | {
      students: Record<string, AssessmentStudent>;
      doScreener?: boolean;
    };

export interface LegacyAssessmentStudent {
  id: string;

  startedAt: number | null;
  completedAt: number | null;
  placementLevel: number | null;

  phase: number;
  control: ControllerType;
  placeAtAssessedLevel: boolean;
  doScreener?: boolean;
}

type Assessment_v1 = Omit<LegacyAssessment, 'students'> & {
  students:
    | (LegacyAssessmentStudent & { doScreener: boolean })[]
    | Record<string, AssessmentStudent>;
  doScreener: boolean;
};
function addDoScreener(old: LegacyAssessment): Assessment_v1 {
  const doScreener = old.doScreener ?? false;

  const students = Array.isArray(old.students)
    ? old.students.map((s) => ({
        ...s,
        doScreener: s.doScreener ?? false,
      }))
    : Object.fromEntries(
        Object.entries(old.students).map(([id, s]) => [
          id,
          {
            ...s,
            doScreener: s.doScreener ?? false,
          },
        ]),
      );

  return {
    ...old,
    doScreener,
    students,
  };
}
type Assessment_v2 = Omit<Assessment_v1, 'students'> & {
  students: Record<string, AssessmentStudent>;
};

function convertStudentsArrayToMap(old: Assessment_v1): Assessment_v2 {
  const students: Record<string, AssessmentStudent> = Array.isArray(
    old.students,
  )
    ? Object.fromEntries(
        old.students.map((s) => {
          const student: AssessmentStudent = {
            startedAt: s.startedAt,
            completedAt: s.completedAt,
            placementLevel: s.placementLevel,

            phase: s.phase,
            control: s.control,
            placeAtAssessedLevel: s.placeAtAssessedLevel,
            doScreener: s.doScreener ?? false,
          };

          return [s.id, student];
        }),
      )
    : old.students;

  return {
    ...old,
    doScreener: old.doScreener ?? false,
    students,
  };
}

export const { migrate: migrateAssessment, version: ASSESSMENT_VERSION } =
  new Migrator<Assessment>({ 1: addDoScreener, 2: convertStudentsArrayToMap });
